export default "__VITE_ASSET__CINSnRMu__"